import { FieldType } from "../../type-system/FieldType";
import {
  ShopifyPriceListKey,
  ShopifyProductVariantKey,
  ShopifyQuantityPriceBreakKey,
  ShopifyQuantityPriceBreakToPriceListKey,
  ShopifyQuantityPriceBreakToProductVariantKey,
  ShopifyQuantityPriceBreakToShopKey,
  ShopifyShopKey,
} from "./keys";
import { ShopifyApiVersion } from "./ShopifyApiVersion";
import { ShopifyDominion } from "./ShopifyDominion";
import { buildConnectionSpec, ConnectionModelSpecVersion } from "./ShopifyMetadata";

const specs: ConnectionModelSpecVersion = {
  key: ShopifyQuantityPriceBreakKey,
  "2024-04": {
    name: "Shopify Quantity Price Break",
    graphQLTypename: "QuantityPriceBreak",
    fields: [
      {
        name: "ID",
        fieldType: FieldType.ID,
        contributorConfiguration: { [ShopifyDominion.id]: { graphQLFieldKey: "id" } },
      },
      {
        name: "Minimum Quantity",
        fieldType: FieldType.Number,
        contributorConfiguration: { [ShopifyDominion.id]: { graphQLFieldKey: "minimumQuantity" } },
      },
      {
        name: "Price",
        fieldType: FieldType.JSON,
        contributorConfiguration: {
          [ShopifyDominion.id]: {
            graphQLFieldKey: "price",
            graphQLSelection: `
            amount
            currencyCode`,
          },
        },
      },
      {
        name: "Price List",
        fieldType: FieldType.BelongsTo,
        key: ShopifyQuantityPriceBreakToPriceListKey,
        contributorConfiguration: { [ShopifyDominion.id]: { graphQLFieldKey: "priceList", graphQLSelection: "id" } },
        configuration: {
          relatedModelKey: ShopifyPriceListKey,
        },
      },
      {
        name: "Variant",
        fieldType: FieldType.BelongsTo,
        key: ShopifyQuantityPriceBreakToProductVariantKey,
        contributorConfiguration: { [ShopifyDominion.id]: { graphQLFieldKey: "variant", graphQLSelection: "id" } },
        configuration: {
          relatedModelKey: ShopifyProductVariantKey,
        },
      },
      {
        name: "Shop",
        fieldType: FieldType.BelongsTo,
        key: ShopifyQuantityPriceBreakToShopKey,
        configuration: {
          relatedModelKey: ShopifyShopKey,
        },
      },
    ],
    syncConfig: {
      type: "custom",
      resource: "quantityPriceBreaks",
      order: "last",
    },
  },
};

export const ShopifyQuantityPriceBreak = ({ apiVersion }: { apiVersion: ShopifyApiVersion }) => buildConnectionSpec(specs, apiVersion);
